<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-21 17:32:24
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 13:36:43
-->
<template>
  <div class="innovative innovative-aneuguide" :class="{textj: language != 'en'}" ref="aneuguide">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div v-if="language == 'en'" class="innovative-bj-title center_up_down_left_right">
        <p v-html="$t('product.aneuguide.title').replace(' Interventional', '<br />Interventional')"></p>
      </div>
      <div v-else class="innovative-bj-title center_up_down_left_right" v-html="$t('product.aneuguide.title')"></div>
    </div>
    <div class="p-t-50 p-b-10">
      <div class="p-l-30 p-r-30">
        <div class="innovative-item-title p-l-25" v-html="$t('product.aneuguide.list[0].title')"></div>
      </div>
      <div class="p-t-28 p-l-1 p-r-8">
        <img class="wid100" :src="$t('product.aneuguide.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 textj">
        <p class="p-t-20 p-b-20" v-for="item, index in $t('product.aneuguide.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div>
      <div class="aneuguide-characteristics">
        <div class="innovative-container">
          <div class="innovative-item-title" v-html="$t('product.aneuguide.list[1].title')"></div>
          <div class="aneuguide-characteristics-box">
            <div class="p-t-30 p-b-30" v-for="item, index in $t('product.aneuguide.list[1].des')" :key="index">
              <div class="innovative-wrap-item-title fz-30 textc p-b-20" v-html="item.title"></div>
              <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
            </div>
            <div class="p-t-30 p-b-30 textc">
              <img style="max-width: 80%;" :src="$t('product.aneuguide.list[1].img')" alt="" srcset="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-container">
      <div class="aneuguide-advantages p-t-10">
        <div class="innovative-item-title widauto ilblk p-r-100" v-html="$t('product.aneuguide.list[2].title')"></div>
        <div class="innovative-characteristics m-b-30" v-for="item, index in $t('product.aneuguide.list[2].des')" :key="index" >
          <img class="wid100" :src="item.img" alt="" srcset="">
          <div class="aneuguide-advantages-des" v-html="item.des"></div>
        </div>
      </div>
      <div class="p-t-20 article">
        <div class="innovative-item-title" v-html="$t('product.aneuguide.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.aneuguide.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-aneuguide {
  .aneuguide-characteristics {
    background-image: url('~@/assets/images/innovate/AneuGuide/m_3.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
    padding: 20px 0;
    .aneuguide-characteristics-box {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 50px 30px;
    }
  }
  .aneuguide-advantages {
    .aneuguide-advantages-des {
      padding: 45px 40px;
      font-size: 28px;
      color: #333333;
      line-height: 40px;
    }
  }
}
</style>
